<template>
  <main class="app-wrapper">
    <RouterView />
  </main>
</template>

<script setup>
import { RouterView } from 'vue-router';
</script>

<style>
.app-wrapper {
  min-height: 100vh;
  background-color: #f5f6fa;
  padding: 2rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  color: #1a1a1a;
}
</style>
